import React, {useCallback, useState} from 'react';
import {Autocomplete, TextField} from '@mui/material';
import {ITag} from '../../../dto/MediaTrack.dto';
import {GetTagList} from '../../../pages/music-section/MusicSectionQueries';
import {useStoreSelector} from '../../../store/configstore';
import {companyIdSelector} from '../../../store/Slices/companySlice';

export const AutoCompleteGetTag = ({
  tag,
  setTag,
  station_id = [],
  school_ids = [],
  event_type_ids = [],
}: {
  tag: ITag | null;
  setTag: (val: ITag | null) => void;
  station_id?: number[];
  school_ids?: number[];
  event_type_ids?: number[];
}) => {
  const companyId = useStoreSelector(companyIdSelector) ?? 0;
  const [search, setSearch] = useState('');
  const {data} = GetTagList(
    {
      per_page: 10,
      search,
      ...(Boolean(companyId) && station_id && {type: 'music-schedule'}),
      ...(Boolean(companyId) && station_id && {company_id: companyId}),
      ...(station_id && {station_id}),
      ...(school_ids && {school_ids}),
      ...(event_type_ids && {event_type_ids}),
    },
    !!search,
  );

  const handleOnChange = useCallback(
    (_: React.SyntheticEvent<Element, Event>, value: ITag | null) => {
      setTag(value);
    },
    [setTag],
  );

  return (
    <Autocomplete
      sx={{minWidth: 200}}
      id='tags-outlined'
      onChange={handleOnChange}
      value={tag}
      options={data ?? []}
      getOptionLabel={(option: ITag) => {
        return option.name;
      }}
      renderInput={params => (
        <TextField
          {...params}
          placeholder='Search Tag'
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      )}
    />
  );
};
